import {
    Button,
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Approval5mcutSelectModal from "../subPage/Approval5mcut/Approval5mcutSelectModal";
import ApprovalSurveySelectModal from "../subPage/ApprovalSurvey/ApprovalSurveySelectModal";
import { portalTypeList } from "../subPage/Portal/PortalFunction";
import dayjs from "dayjs";
import { encryptQueryParam } from "../../utility/util";
import { useUtilityContext } from "../../utility-provider";

interface ModalProps {
    props: {
        modalOpen: boolean;
        setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
        planAreaId: string;
        obj: portalTypeList[] | undefined;
    };
}

interface dataTypeList {
    id: string;
    rfc_request_date: string;
    elapsedTime: string;
    type: string;
    department: string;
    district: string;
    rfc: string;
    plan_area_id: string;
    candidateSiteName: string;
    assembly: string;
    pattern: string;
    branch: string;
    status_id: string;
    pic_type: string;
    pic_name: string;
    task_id: string;
    reception_no: string;
}

//TableCellのヘッダースタイル変更
const TableCellSx = {
    backgroundColor: "#00CC5B",
    color: "#fff",
};
//TableRowのカーソルをポインターへ変更
const TableRowSx = {
    cursor: "pointer",
    "&: hover": {
        backgroundColor: "#ebfbec",
    },
};

const ResearchBranchModal: React.FC<ModalProps> = ({ props }) => {
    const utilityCtx = useUtilityContext();

    const [propsObj, setPropsObj] = useState<any[]>();

    const [approvalOpen, setApprovalOpen] = useState<boolean>(false);
    const [surveyApprovalOpen, setSurveyApprovalOpen] =
        useState<boolean>(false);
    const [planAreaId, setPlanAreaId] = useState("");
    const [branch, setBranch] = useState("");

    //調査書(ロングページ)表示
    const handleRowClick = (branchType: string, task_id: string) => {
        let url = "";
        if (["D004", "D005", "D007", "D008", "D010"].includes(task_id)) {
            // 【立地調査リリース後対応】5m外、商圏カット承認用ページ
            setPlanAreaId(props.planAreaId);
            setBranch(branchType);
            setApprovalOpen(true);
        } else if (
            [
                "E001",
                "E002",
                "E010",
                "E012",
                "E014",
                "E002",
                "E003",
                "E011",
                "E013",
                "E015",
            ].includes(task_id)
        ) {
            // 【立地調査リリース後対応】追加調査承認ページ
            setPlanAreaId(props.planAreaId);
            setBranch(branchType);
            setSurveyApprovalOpen(true);
        } else {
            // ロングページ遷移(URLクエリパラメータ暗号化)
            if (utilityCtx.showSpinner) {
                utilityCtx.showSpinner();
            }
            const param = `planAreaId=${props.planAreaId}&branch=${branchType}`;
            encryptQueryParam(param).then((res) => {
                const url = '/LongPage?' + res;
                window.open(url);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }).catch((e:any) => {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            });
        }
    };

    //モーダルクローズ
    const handleResearchBranchClose = () => {
        props.setModalOpen(false);
    };

    //フラグ値セット関数
    const setFlagNo = (receptionNo: string) => {
        let flagNo: string = "";
        if (receptionNo !== null) {
            flagNo = receptionNo.slice(8, -1);
        }
        return flagNo;
    };

    //ポータルコンポーネントからのデータセット
    useEffect(() => {
        const obj = props.obj;
        //受付No(10桁)からフラグ値抽出
        if (typeof obj !== "undefined") {
            // 元のデータを変更しないようにコピーを作成
            const copiedObj = obj.map((elem) => ({
                ...elem,
                reception_no: setFlagNo(elem.reception_no)
            }));
            setPropsObj(copiedObj);
        }
    }, [props.modalOpen]);

    const registPDF = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, location: string, value: any) => {
        e.stopPropagation();
        // PDF一覧ページ遷移(URLクエリパラメータ暗号化)
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        const param = `planAreaId=${value.plan_area_id}&branch=${value.branch}`;
        encryptQueryParam(param).then((res) => {
            const newTabUrl = `${window.location.origin}${location}?` + res;
            window.open(newTabUrl);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    };

    const closeApprovalModal = (hasOpen: boolean) => {
        setApprovalOpen(hasOpen);
    };

    const closeSurveyApprovalModal = (hasOpen: boolean) => {
        setSurveyApprovalOpen(hasOpen);
    };

    const rfcRequestDate = (date: string) => {
        if (date) {
            return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
        }
        return "";
    };

    return (
        <Box>
            {/* 調査書枝選択画面モーダル */}
            <Dialog
                open={props.modalOpen}
                onClose={handleResearchBranchClose}
                fullWidth
            >
                <DialogTitle sx={{ textAlign: "center" }}>
                    閲覧する枝を選択してください
                </DialogTitle>
                <DialogContent>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={TableCellSx}>
                                        ステータス
                                    </TableCell>
                                    <TableCell sx={TableCellSx}>
                                        更新日時
                                    </TableCell>
                                    <TableCell sx={TableCellSx}>
                                        フラグ
                                    </TableCell>
                                    <TableCell sx={TableCellSx}>枝</TableCell>
                                    <TableCell sx={TableCellSx}>PDF</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {typeof propsObj !== "undefined" &&
                                    propsObj.map((value: any, index: any) => (
                                        <TableRow
                                            key={index}
                                            sx={TableRowSx}
                                            onClick={() => {
                                                handleRowClick(
                                                    value.branch,
                                                    value.task_id
                                                );
                                            }}
                                        >
                                            <TableCell>
                                                {value.status_name}
                                            </TableCell>
                                            <TableCell>
                                                {rfcRequestDate(
                                                    value.rfc_request_date
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {value.reception_no}
                                            </TableCell>
                                            <TableCell>
                                                {value.branch}
                                            </TableCell>
                                            <TableCell>
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    size="small"
                                                    onClick={(e) =>
                                                        registPDF(
                                                            e,
                                                            "/PdfSummary",
                                                            value
                                                        )
                                                    }
                                                >
                                                    PDF
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
            </Dialog>
            <Approval5mcutSelectModal
                props={{
                    open: approvalOpen,
                    handleModal: closeApprovalModal,
                    planAreaId: planAreaId,
                    branch: branch,
                }}
            />
            <ApprovalSurveySelectModal
                props={{
                    open: surveyApprovalOpen,
                    handleModal: closeSurveyApprovalModal,
                    planAreaId: planAreaId,
                    branch: branch,
                }}
            />
        </Box>
    );
};

export default ResearchBranchModal;
